import { render, staticRenderFns } from "./additional-container.vue?vue&type=template&id=106f3eff&scoped=true&"
import script from "./additional-container.vue?vue&type=script&lang=js&"
export * from "./additional-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106f3eff",
  null
  
)

export default component.exports